import type { ResponseMessage } from '@kiddocare-platform/portal-common/base'
import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import type { Illness } from '@kiddocare-platform/portal-common/family'
import { isCacheValid } from '../../../entry.cache'
import type { FamilyCacheState } from '../types'

const addIllnesseses: CaseReducer<
  FamilyCacheState,
  PayloadAction<ResponseMessage<Array<Illness>>>
> = (state, action) => {
  state.illnesses = { value: action.payload, cachedAt: Date.now() }
}

const removeIllnesseses: CaseReducer<FamilyCacheState, PayloadAction<void>> = (state) => {
  state.illnesses = undefined
}

const purgeExpiredIllnessesCache: CaseReducer<FamilyCacheState> = (state) => {
  if (!isCacheValid(state.illnesses)) {
    state.illnesses = undefined
  }
}

export const illnessesesReducers = {
  addIllnesseses,
  removeIllnesseses,
  purgeExpiredIllnessesCache,
}
